import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-244" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-245" data-mp="cn7riumnqbzc">
        <div className="text-center mb-16" data-id="element-246" data-mp="cm508llfa7iw">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-3 text-brand" data-id="element-247" data-mp="7qhcmaml9mfi">
            What You Get: 6 Complete Resources in One Package
          </h2>
          <p className="text-lg text-ink/70 max-w-2xl mx-auto mb-10" data-id="element-248" data-mp="3c3mkahs7hqzl">
            4 full lesson volumes + 2 essential teaching tools — everything structured, everything ready, nothing to
            build from scratch.
          </p>
          <p className="text-gold-dark font-bold tracking-widest uppercase mb-2" data-id="element-249" data-mp="3l42hj9icw1w0">📚 The 4-Volume Lesson Library</p>
          <p className="text-xl text-forest" data-id="element-250" data-mp="2xdfa0pccre9z">
            100 Complete Lessons · All Levels Covered · Nothing to Build from Scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-251" data-mp="29fs2gaqjm17t">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-cream rounded-2xl border ${volume.popular ? 'border-gold shadow-[0_16px_40px_-24px_rgba(15,61,46,0.45)]' : 'border-mist'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-252" data-mp="2eebt2og3016i" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-gold text-brand font-bold text-xs py-1 px-10 rotate-45 shadow-md" data-id="element-253" data-mp="20drbfvlwkbel">
                  ⭐ MOST POPULAR
                </div>}
              <div className="flex items-center gap-4 mb-6" data-id="element-254" data-mp="3bt7h8iw03iye">
                <span className="text-4xl" aria-hidden="true" data-id="element-255" data-mp="3fvawlilsj7oy">
                  {volume.icon}
                </span>
                <div data-id="element-256" data-mp="1gq1emmcipyql">
                  <div className="text-gold-dark font-bold text-sm uppercase tracking-wider" data-id="element-257" data-mp="1gphsetfu4o6r">{volume.number}</div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-brand" data-id="element-258" data-mp="1brgcuihmb701">{volume.title}</h3>
                </div>
              </div>
              <p className="text-forest font-medium mb-6 italic border-l-2 border-gold pl-4" data-id="element-259" data-mp="1krwfjpqjea3u">{volume.subtitle}</p>
              <div className="mb-6" data-id="element-260" data-mp="x3v9qokqt7s4">
                <h4 className="text-sm font-bold text-mist-text uppercase tracking-wider mb-2" data-id="element-261" data-mp="x0qy564y79rf">
                  What does this solve for your teaching?
                </h4>
                <p className="text-ink/75 text-sm leading-relaxed" data-id="element-262" data-mp="16teszvcdb3ni">{volume.problem}</p>
              </div>
              <ul className="space-y-3 mb-8 flex-grow" data-id="element-263" data-mp="120dcjiwiiw1t">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-264" data-mp="eaj0v4nxjdj5">
                    <CheckCircle2 size={18} className="text-forest shrink-0 mt-0.5" aria-hidden="true" data-id="element-265" data-mp="9c7s6x9df92i" />
                    <span className="text-ink/80 text-sm" data-id="element-266" data-mp="2kzt20r9n1rvd">{bullet}</span>
                  </li>)}
              </ul>
              <div className="bg-sand/60 border border-gold/40 rounded-xl p-4 mt-auto" data-id="element-267" data-mp="2ptfi6tf0gdvx">
                <span className="text-gold-dark font-bold block mb-1" data-id="element-268" data-mp="2c1r44kl7bfcb">Result:</span>
                <p className="text-brand text-sm" data-id="element-269" data-mp="2gzsl8zz2h4l5">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}